/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { GET_PDF } from '../../api/graphql';
import { useApplication } from '../provider';
import { FormatAppService } from './formatApp.plugin';
import { getErrorMessage } from '@/utils/error.message';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IGetPdfMethods extends IPluginMethodMap {
  getPdfDetail(args: any): Promise<any>;
}

export class GetPdfService implements IAgentPlugin {
  readonly methods: IGetPdfMethods;

  constructor() {
    this.methods = {
      getPdfDetail: this.getPdfDetail.bind(this),
    };
  }

  private async getPdfDetail(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const { credentialNo } = useApplication();
    console.log("eette",args)
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_PDF, {
          applicationNo: args,
        });
        console.log(`pdf download data`, res);
        if (res && res?.data && res?.data?.genarateApplicationPDF) {
          return res?.data?.genarateApplicationPDF
        }
        else{
          getErrorMessage(res?.error);
          // throw res?.error;
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }
}
